import { PServed } from '@wui/im'

import { getAbsoluteURL } from './full-url'

export interface InviteTokenSource {
  roomPServed: PServed
  roomToken?: string
  prepareToCall?: boolean
}

const INVITE_TOKEN_ENCODE_DELIMITER = '+'

export const getInviteLoginAbsoluteURL = (source: InviteTokenSource): string => {
  const { roomPServed, roomToken } = source
  let inviteToken = `${roomPServed}${INVITE_TOKEN_ENCODE_DELIMITER}${roomToken!}`
  if (source.prepareToCall) {
    inviteToken += `${INVITE_TOKEN_ENCODE_DELIMITER}${source.prepareToCall}`
  }
  return getAbsoluteURL(`/#/invite-login/${btoa(inviteToken)}`)
}

export const getParamsFromInviteToken = (inviteToken: string): InviteTokenSource => {
  const [roomPServed, roomToken, prepareToCall] = atob(inviteToken).split(INVITE_TOKEN_ENCODE_DELIMITER)
  return {
    roomPServed: roomPServed!,
    roomToken: roomToken!,
    prepareToCall: !!prepareToCall,
  }
}
